var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-lg-12\">\n<div ng-if=\"prevartCtrl.caricamento\">\n<i>...Attendi</i>\n</div>\n<section ng-if=\"!prevartCtrl.caricamento\">\n<center>\n<img width=\"450\" ng-src=\"{{prevartCtrl.articolo.linkFoto}}\" alt=\"[{{prevartCtrl.articolo.codarticolo}}] {{prevartCtrl.articolo.descrizione}}\" title=\"[{{prevartCtrl.articolo.codarticolo}}] {{prevartCtrl.articolo.descrizione}}\"/>\n</center>\n</section>\n</div> ";
var id1="previewart.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;